import React__default, { useState, useRef, useEffect, useContext } from 'react';
import { debounce } from 'lodash-es';
import { H as Helpers, Q as QuantumConfig } from './index-72ff421b.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppColoursSelectionComponent } from './index-2277a72b.esm.js';
import { a as availableEmojis, b as availableColours } from './index-ce6ef2b2.esm.js';
import { A as AppForm, a as AppSubmitButton } from './AppSubmitButton-2e6a9268.esm.js';
import { A as AppFormField } from './AppFormField-e5fa211c.esm.js';
import { A as AppFormPicker } from './AppFormPicker-04baca06.esm.js';
import * as Yup from 'yup';

// # DEPRECATEDimport React, { useContext, useState } from "react";
const initialState = {
  NERStyles: [],
  dispatch: (a, p) => {}
};
const QuantumEditorContext = /*#__PURE__*/React__default.createContext(initialState);
// new line custom hook

const QuantumEditorProvider = _ref => {
  let {
    children,
    nlpConfig,
    editorState,
    rawEditorState,
    onChange,
    isAIEnabled,
    NERStyles,
    IntentStyles
  } = _ref;
  const [extractedEntities, setExtractedEntities] = useState([]);
  const [indexesInContext, setIndexesInContext] = useState([]);
  const delayedEntitiesAnalysis = useRef(debounce((editorState, setExtractedEntities) => {
    const mentions = Helpers.extractEntitiesByType(editorState, "MENTION");
    const tags = Helpers.extractEntitiesByType(editorState, "TAG");
    setExtractedEntities([...mentions, ...tags]);
  }, QuantumConfig.MENTIONS_EXTRACTION_TIMER)).current;
  const getStyleForEntityType = entityLabel => {
    return NERStyles.filter(nerS => nerS.label === entityLabel)[0];
  };
  const getEditorState = () => {
    return editorState;
  };
  const setEditorState = editorState => {
    onChange(editorState);
  };
  useEffect(() => {
    delayedEntitiesAnalysis({
      children: editorState
    }, setExtractedEntities);
  }, [editorState, delayedEntitiesAnalysis]);
  return /*#__PURE__*/React__default.createElement(QuantumEditorContext.Provider, {
    value: {
      getStyleForEntityType,
      getEditorState,
      setEditorState,
      rawEditorState,
      extractedEntities,
      isAIEnabled,
      NERStyles,
      IntentStyles,
      nlpConfig,
      indexesInContext,
      setIndexesInContext
    }
  }, children);
};
const useQuantumEditor = () => {
  const {
    getStyleForEntityType,
    getEditorState,
    setEditorState,
    rawEditorState,
    extractedEntities,
    isAIEnabled,
    NERStyles,
    IntentStyles,
    nlpConfig = {},
    setIndexesInContext,
    indexesInContext
  } = useContext(QuantumEditorContext);
  return {
    getStyleForEntityType,
    getEditorState,
    setEditorState,
    rawEditorState,
    extractedEntities,
    isAIEnabled,
    NERStyles,
    IntentStyles,
    nlpConfig,
    setIndexesInContext,
    indexesInContext
  };
};
QuantumEditorProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuantumEditorProvider"
};

const NERFormInitialValues = {
  addNER: {
    label: "",
    icon: "",
    backgroundColor: "",
    id: ""
  }
};
const NERValidationsAddNER = NERStyles => {
  const NERStyleLabels = NERStyles === null || NERStyles === void 0 ? void 0 : NERStyles.map(e => {
    return e.label.toLowerCase();
  });
  return Yup.object().shape({
    label: Yup.string().required().lowercase().notOneOf(NERStyleLabels, "The label already exists").label("Label"),
    icon: Yup.string().required().label("Emoji"),
    backgroundColor: Yup.string().required().min(7).label("Background color")
    // id: yup.string().required().label("id"),
  });
};

const AnnotationToolBarModalComponents = _ref => {
  var _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6;
  let {
    handleSubmissionOfNeNER
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const {
    state
  } = useQuantumEditor();
  let _validationSchema = (state === null || state === void 0 ? void 0 : state.NERStyles) && NERValidationsAddNER(state === null || state === void 0 ? void 0 : state.NERStyles);
  useEffect(() => {
    if (state !== null && state !== void 0 && state.NERStyles) _validationSchema = NERValidationsAddNER(state === null || state === void 0 ? void 0 : state.NERStyles);
  }, [state === null || state === void 0 ? void 0 : state.NERStyles]);
  return /*#__PURE__*/React__default.createElement(AppForm, {
    enableReinitialize: true,
    requiresReset: true,
    initialValues: NERFormInitialValues.addNER,
    onSubmit: v => handleSubmissionOfNeNER(v),
    validationSchema: _validationSchema
  }, /*#__PURE__*/React__default.createElement(AppFormField, {
    style: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.medium_font_size
    },
    showTextInputLabel: true,
    label: "Label",
    isMandatory: true,
    autoCapitalize: "none",
    keyboardType: "default",
    autoCorrect: false,
    name: "label"
  }), /*#__PURE__*/React__default.createElement(AppFormPicker, {
    style: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.medium_font_size
    },
    itemLabelStyle: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.largest_font_size
    },
    width: 280,
    pickerType: "emoji",
    options: availableEmojis,
    numberOfColumns: 4,
    showTextInputLabel: true,
    label: "Icon",
    name: "icon",
    itemFontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.medium_font_size
  }), /*#__PURE__*/React__default.createElement(AppFormPicker, {
    numberOfColumns: 4,
    optionLabel: null,
    style: {
      fontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.medium_font_size
    },
    width: 280,
    PickerItemComponent: AppColoursSelectionComponent,
    options: availableColours,
    showTextInputLabel: true,
    label: "Highlight color",
    name: "backgroundColor",
    itemFontSize: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.medium_font_size
  }), /*#__PURE__*/React__default.createElement(AppSubmitButton, {
    style: {
      alignSelf: "center"
    },
    title: "Create"
  }));
};
AnnotationToolBarModalComponents.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AnnotationToolBarModalComponents"
};

export { AnnotationToolBarModalComponents as A, QuantumEditorProvider as Q, useQuantumEditor as u };
